var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-dark text-white"},[_c('b-container',{staticClass:"py-5"},[_c('p',{staticClass:"h4 mb-0 text-center"},[_vm._v("© エアコン販売王")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }